import type { UiContainer } from "~/models/ui";
import TGCOMLogo from "./TGCom24_logo.webp?jsx";

interface SidebarBreakingNewsProps extends UiContainer {
  time: string;
  title: string;
}

export const SidebarBreakingNews = ({
  time,
  title,
  class: className,
}: SidebarBreakingNewsProps) => {
  return (
    <div
      class={["sgtv-flex sgtv-h-24 sgtv-w-full sgtv-font-roboto", className]}
    >
      <a
        href="https://www.tgcom24.mediaset.it"
        target="_blank"
        class="sgtv-flex sgtv-h-24 sgtv-w-full sgtv-text-white"
      >
        <div class="sgtv-bg-blue sgtv-h-full sgtv-w-1/3 sgtv-min-w-16 sgtv-max-w-40 sgtv-bg-gradient-to-b sgtv-from-blue-900 sgtv-from-0% sgtv-to-blue-950 sgtv-to-100%">
          <div class="sgtv-relative sgtv-h-1/2 sgtv-w-full">
            <div class="sgtv-relative sgtv-block sgtv-h-full sgtv-border-x-8 sgtv-border-t-4 sgtv-border-solid sgtv-border-transparent md:sgtv-border-x-4">
              <TGCOMLogo
                alt="TGCOM Logo"
                class="sgtv-absolute sgtv-bottom-0 sgtv-left-0 sgtv-right-0 sgtv-top-0 sgtv-mx-auto sgtv-mb-0 sgtv-mt-auto sgtv-h-auto sgtv-max-h-full sgtv-w-full sgtv-max-w-full sgtv-border-0"
              />
            </div>
          </div>
          <div class="sgtv-table sgtv-h-1/2 sgtv-w-full sgtv-text-center sgtv-text-white">
            <p class="sgtv-table-cell sgtv-align-middle sgtv-text-2xl sm:sgtv-text-3xl md:sgtv-text-xl lg:sgtv-text-2xl">
              {time}
            </p>
          </div>
        </div>
        <div class="sgtv-relative sgtv-h-full sgtv-w-full sgtv-bg-gradient-to-b sgtv-from-red-600 sgtv-from-0% sgtv-to-red-800 sgtv-to-100%">
          <p class="sgtv-pb-1 sgtv-pl-2 sgtv-pt-2 sgtv-text-2xl sgtv-uppercase sgtv-leading-5 md:sgtv-py-0 md:sgtv-pl-1 md:sgtv-text-2xl md:sgtv-leading-8">
            ULTIM&#x27;ORA
          </p>
          <p class="sgtv-max-h-11 sgtv-overflow-hidden sgtv-text-ellipsis sgtv-pr-0.5 sgtv-pt-0.5 sgtv-text-sm sgtv-leading-none">
            {title}
          </p>
          <p class="sgtv-absolute sgtv-bottom-1 sgtv-right-2 sgtv-text-right sgtv-text-xs">
            TUTTE LE NEWS
          </p>
        </div>
      </a>
    </div>
  );
};
